// extracted by mini-css-extract-plugin
export default {"termsLink":"LoginForm_termsLink__CjVLZ","popup":"LoginForm_popup__hgXiA"};